import { render } from "./declare_all_done.vue?vue&type=template&id=223b808e"
import script from "./declare_all_done.vue?vue&type=script&lang=js"
export * from "./declare_all_done.vue?vue&type=script&lang=js"

import exportComponent from "/var/deploy/production_one/web_head/releases/20260519225119/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__